import { EMPTY_STRING } from '../../../../../constants/common'
import { ATTACH_SERVICE_REQUESTS_AI_REASON_KEY } from '../../AttachServiceRequestsModal.constants'

export function getAISuggestionsPanelRowReasonText(reason, t) {
  if (!reason) {
    return EMPTY_STRING
  }

  return reason
    .split(',')
    .map(reasonPart => reasonPart.trim())
    .filter(reasonPart => reasonPart.length > 0)
    .map(reasonPart =>
      ATTACH_SERVICE_REQUESTS_AI_REASON_KEY[reasonPart]
        ? t(ATTACH_SERVICE_REQUESTS_AI_REASON_KEY[reasonPart])
        : reasonPart
    )
    .join(', ')
}
